import { IPageData, IPageParams } from "../types"

/**
 * $t('enum.E_ScoreStatus.NeedData')
 * $t('enum.E_ScoreStatus.Normal')
 */
export enum E_ScoreStatus {
    /**
     * 缺少数据
     */
    NeedData = 1,
    /**
     * 正常
     */
    Normal = 2,
}

/**
 * 是否报警
 * $t('enum.E_ScoreAlarmStatus.Yes')
 * $t('enum.E_ScoreAlarmStatus.No')
 */
export enum E_ScoreAlarmStatus {
    /**
     * 报警
     */
    Yes = 1,
    /**
     * 未报警
     */
    No = 0
}


export interface IPointMappingBase {
    companyId: number
    areaId: number
    mappingName: number
    equipmentId: number
    sensorId: string
    id: number
    companyName: string
    areaName: string
    equipmentName: string
    dataMin: string
    dataMax: string
    accelerationMin: number | null
    accelerationMax: number | null
    velocityMin: number | null
    velocityMax: number | null
    kurtosisMin: number | null
    kurtosisMax: number | null
    peakFactorMin: number | null
    peakFactorMax: number | null
    envelopeMin: number | null
    envelopeMax: number | null
    mappingId: number
    status: E_ScoreStatus
    startTime: string
    endTime: string
}

export interface IScoreBaseBaselineParams {
    mappingId: number
    accelerationMin: number
    accelerationMax: number
    velocityMin: number
    velocityMax: number
    kurtosisMin: number
    kurtosisMax: number
    peakFactorMin: number
    peakFactorMax: number
    envelopeMin: number
    envelopeMax: number
}


export type IScoreBasePageListParams = IPageParams & Partial<{
    companyId: number
    areaId: number
    mappingName: number
    equipmentId: number
    sensorId: string
    startTime: string
    endTime: string
    status: E_ScoreStatus
}>

export type IScoreBasePageListData = IPageData<IPointMappingBase>

export interface IScoreBaseScoreEquipmentDetailItem {
    dataTime: string
    companyId: number
    areaId: number
    equipmentId: number
    equipmentName: string
    mappingId: number
    mappingName: string
    score: number
    /** 设备评分记录 ID */
    scoreId?: number | null
    /** 修正前评分，历史记录为 null */
    originalScore?: number | null
    /** 评分所属自然日 */
    scoreTime?: string | null
    /** 0 未修正、1 高分修正、2 低分修正 */
    correctionFlag?: 0 | 1 | 2 | null
    /** 当天是否存在报警 */
    alarmFlag?: 0 | 1 | null
    diagnosisList?: IScoreDiagnosisItem[]
}

export interface IScoreDiagnosisItem {
    diagnosisId: number
    mappingId: number
    mappingName: string
    diagnosisTime: string
    diagnosisCode: string
    conclusion: string
}

export interface IScoreBaseScoreEquipmentDetailsParams {
    startTime: string
    endTime: string
    equipmentId: number
}

export type IScoreBaseScoreEquipmentDetailsData = IScoreBaseScoreEquipmentDetailItem[]


export type IScoreBaseScoreEquipmentPageListParams = IPageParams & Partial<{
    companyId: number
    areaId: number
    mappingName: string
    equipmentId: number
    scoreMax: number
    scoreMin: number
}>

export type IScoreBaseScoreEquipmentPageListData = IPageData<IScoreBaseScoreEquipmentDetailItem>

export interface IScoreBaseScoreEquipmentStatisticsParams {
    companyId: number
}

export interface IScoreBaseScoreEquipmentStatisticsData {
    /**
     * 0-59分
     */
    equipmentNum1: number
    /**
     * 60-79分
     */
    equipmentNum2: number
    /**
     * 80-100分
     */
    equipmentNum3: number
}

export interface IPointMappingScoreItem {
    alarmStatus: E_ScoreAlarmStatus
    companyId: number
    areaId: number
    mappingName: number
    equipmentId: number

    id: number
    companyName: string
    areaName: string
    equipmentName: string
    mappingId: number
    status: E_ScoreStatus
    startTime: string
    endTime: string

    parentCompanyId
    dataId

    az
    bfZ
    qz
    vz
    score
}


export type IScoreBaseScoreMappingPageListParams = IPageParams & Partial<{
    companyId: number
    areaId: number
    mappingName: number
    equipmentId: number
    startTime: string
    endTime: string
    status: E_ScoreStatus
}>

export type IScoreBaseScoreMappingPageListData =
    IPageData<IPointMappingScoreItem>

export interface IPointMappingScoreDetailsItem {
    mappingId
    mappingName
    alarmStatus: E_ScoreAlarmStatus
    az
    bfZ
    qz
    vz
    score
}

export interface IScoreBaseScoreListParams {
    companyId: number
    areaId: number
    equipmentId: number
    startTime?: string
    endTime?: string
    mappingId: number
    status?: E_ScoreAlarmStatus
}
export type IScoreBaseScoreListData = IPointMappingScoreDetailsItem[]

export type IScoreBaseScorePageListParams = IPageParams & IScoreBaseScoreListParams

export type IScoreBaseScorePageListData = IPageData<IPointMappingScoreDetailsItem>

export interface IScoreBaseScoreTrainingParams {
    startTime: string
    endTime: string
    mappingIds: number[]
}

export type IScoreBaseScoreTrainingData = any

export type IScoreBaseGetToggleHiScoreStatusData = number

export type IScoreBaseToggleHiScoreStatusData = number


export interface IScoreBaseScoreEquipmentListParams {
    companyId?: number
    areaId?: number
    mappingName?: string    
    scoreMax?: number
    scoreMin?: number
}

export interface IScoreBaseScoreEquipmentListData {
    /**
     * 0-59分
     */
    equipmentNum1: number
    /**
     * 60-79分
     */
    equipmentNum2: number
    /**
     * 80-100分
     */
    equipmentNum3: number
}
